<template>
    <div>
        <TopBar :listing="listing"/>
        <div class="px-4 mt-10">
            <div class="md:flex md:-mx-2">
                <div v-if="listing" class="px-2 w-full md:w-3/12 mb-2">

                    <div class="relative pb-3/4" style="">
                        <img :src="listing.image.src + timeStamp" alt="" class="absolute h-full w-full h-48 w-full object-cover"/>
                    </div>


                    <div>
                        <strong ignore>{{listing.address}}</strong>
                        <div class="text-sm" ignore>{{listing.city}}, {{listing.state}}</div>
                    </div>
                    <LeftNav :listing="listing"/>
                </div>
                <div class="px-2 w-full md:w-8/12 mb-2">
                    <Card title="Listing Overview">
                        <Overview :listing="listing"/>
                    </Card>
                </div>
                <div class="px-2 w-full md:w-3/12">

                    <button type="button" class="btn-pill bg-blue-500 text-white hover:bg-blue-400 mb-3 p-3 font-bold" v-if="pendingFB"
                            @click="goToUrl(cpixdomain + '/aspen/facebookPendingPost.htm?objectType=Realtor', true)">
                      <i class="fas fa-check-circle text-blue-300 mr-2"></i> Approve <span ignore>Facebook</span> Post
                    </button>

                    <div class="flex -mx-1" v-if="listing">

                        <a href="#" @click.prevent="viewTourSite" class="btn-pill mx-1 ">
                            <i class="fas fa-laptop text-green-500"></i> View Tour Site
                        </a>

                        <a href="#" @click.prevent="deactivateTour" v-if="listing.active" class="btn-pill mx-1">
                            <i class="fas fa-laptop text-red-500"></i> Deactivate Tour
                        </a>

                        <a href="#" @click="activateTour" v-if="!listing.active" class="btn-pill mx-1">
                            <i class="fas fa-laptop text-green-500"></i> Activate Tour
                        </a>

                    </div>

                    <Card>
                        <Actions :listing="listing"/>
                    </Card>

                    <div class="mt-4">
                        <Card title="Tour Links &amp; Assets">
                            <TourLinks :listing="listing"/>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Card from '../../components/Card';
  import ListingTopBar from './ListingTopBar';
  import TourLinks from './TourLinks';
  import ListingOverview from "./ListingOverview";
  import ListingLeftNav from "./ListingLeftNav";
  import ListingActions from "./ListingActions";
  import {cpixdomain} from "../../config.js";
  import Swal from 'sweetalert2'


  export default {
    name: "ListingInfo",
    components: {
      'LeftNav': ListingLeftNav,
      'Card': Card,
      'TourLinks': TourLinks,
      'TopBar': ListingTopBar,
      'Overview': ListingOverview,
      'Actions': ListingActions,
    },
    props: ['listing'],
    computed: {
      cpixdomain() {
        return cpixdomain;
      },
      timeStamp() {
        return '?' + Date.now();
      }
    },
    data: function () {
      return {
        'pendingFB': 0
      }
    },
    methods: {
      viewTourSite(){
        this.goToUrl(this.listing.links.branded, true)
      },

      deactivateTour(){
        Swal.fire({
          title: 'Deactivate Tour!',
          text: 'Do you want to deactivate the tour',
          type: 'error',
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: 'Deactivate'
        }).then((result) => {
          if (result.value) {
            this.goToUrl(cpixdomain + '/aspen/index.htm?deactivateTour=true&tourid=' + this.listing.id, true)()
          }
        })
      },

      activateTour(){
        Swal.fire({
          title: 'Activate Tour',
          text: 'Do you want to activate the tour',
          type: 'success',
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: 'Activate'
        }).then((result) => {
          if (result.value) {
            this.goToUrl(cpixdomain + '/aspen/index.htm?activateTour=true&tourid=' + this.listing.id, true)
          }
        })
      },

      goToUrl(url, newTab) {
        if (!newTab) {
          window.location.href = url;
          return;
        }

        window.open(url);
      }
    },
    mounted: function () {
      this.$http.get("/social/scheduled/facebooksession?countOnly=1")
        .then(res => {
          this.pendingFB = res.data;
        });
    }
  };
</script>

<style lang="scss">
    .btn-pill {
        @apply bg-white mb-2 px-2 py-3 rounded text-left text-xs w-full shadow text-gray-700;

        &:active,
        &:hover {
            @apply bg-gray-100 text-gray-700 no-underline;
        }

    }

    .btn-pill:hover {
        @apply border-gray-300;
    }

    #fbApprove {
        width: 100%;
        height: 54px;
        background: #279DD9;
        border-radius: 3px;
        text-align: left;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 15px;
    }


    .smallButton {
        width: 48%;
        height: 39px;

        background: #FFFFFF;
        border-radius: 3px;
        border-color: #FFFFFF;

        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 15px;
        color: #666666;
        margin: 0 0 20px 0;
    }
</style>
